import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Recommandation } from 'src/app/shared/models/remmandation';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-recommandation',
  standalone: false,
  templateUrl: './recommandation.component.html',
  styleUrl: './recommandation.component.scss'
})

export class RecommandationComponent {

  // breadcrumb items

  filteredData: any[] = []; // Données filtrées
  searchTerm: string = ''; // Terme de recherche
  recommadationItems: any = [];
  modalRef: NgbModalRef | null = null;
  paginatedItems: any[] = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;
  item: Recommandation = new Recommandation();
  updateitem: Recommandation = new Recommandation();
  itemToDelete!: any;
  @ViewChild('recoommandationModal') modalContent!: TemplateRef<any>;
  @ViewChild('addrecoommandationModal') modalContent1!: TemplateRef<any>;
  missionItems: any[] = [];
  //typemissionItems: any[] = []; 
  serviceItems: any[] = [];
  mission: any = {};
  constructor(
    private modalService: NgbModal,

    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {

    // this.projetService.projetCreated$.subscribe(() => {
    //   this.fetchDataAction();
    // });
  }

  ngOnInit(): void {

    this.mission = this.localstorage.getRecommandation();
    this.getRecommandationByMission(this.mission);
    this.getListServices();

  }

  //liste des missions
  getListMissions() {
    this.paramservice.getAllMission().subscribe(
      (response: any) => {
        this.missionItems = response.data;
      },
      (error) => {
      }
    );
  }//end getListMissions

  //liste des services
  getListServices() {
    this.paramservice.fetchDataService().subscribe(
      (response: any) => {
        this.serviceItems = response.data;
      },
      (error) => {
        ////console.log("une erreur est survenu",error);
      }
    );
  }//end getListServices

  //liste des recommandations
  getRecommandationByMission(item: any) {
    this.isLoading = true;

    this.paramservice.getRecommandationByMission(item.reference).subscribe(
      (response: any) => {
        //this.getTypeMission();

        this.isLoading = false;
        this.recommadationItems = response.data;
        this.filteredData = [...this.recommadationItems]; // Initialiser filteredData avec toutes les données
        this.totalRecords = this.filteredData.length;
        this.updatePagination();
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }//end getRecommandation


  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePagination();
  }


  updatePagination() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.filteredData.slice(start, end);

    ////console.log("this.updateRessourceStats",this.paginatedItems);
  }
  applyFilter(term: string) {
    this.searchTerm = term.trim().toLowerCase();

    if (this.searchTerm) {
      this.filteredData = this.recommadationItems.filter(item =>
        item.libelle.toLowerCase().includes(this.searchTerm)
      );
    } else {
      // Réinitialiser les données filtrées si la recherche est vide
      this.filteredData = [...this.recommadationItems];
    }

    this.totalRecords = this.filteredData.length;
    this.first = 0; // Revenir à la première page après le filtrage
    this.updatePagination();
  }




  addProjetToActiviter(item: any) {

    ////console.log("item");

    this.localstorage.saveProjetActivite(item);

    this.router.navigate(['/suivi/planification/projet-activite'])
  }



  openModal() {

    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }



  EditModal(item: any) {
    console.log("item", item);


    this.updateitem = item;
    this.updateitem.mission_id = this.mission.reference;
    const dateRecommandation = new Date(item.date_recommandation);
    const formattedDateRecommandation = dateRecommandation.toISOString().split('T')[0]; //
    this.updateitem.date_recommandation = formattedDateRecommandation

    const dateEcheance = new Date(item.date_echeance);
    const formattedDateEcheance = dateEcheance.toISOString().split('T')[0]; //
    this.updateitem.date_echeance = formattedDateEcheance


    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }
  close() {
    this.modalService.dismissAll()
  }
  addRecomandation(modal: any) {
    this.item.mission_id = this.mission.reference;

    if (!this.item.canSave()) {
      this.messageService.add({
        severity: 'error',
        summary: Constant.suiviTitle,
        detail: this.item.getErrorMessage()
      });
      return;
    }

    this.ngxService.start();

    this.paramservice.addRecommndation(this.item).subscribe(
      (response: any) => {
        this.messageService.add({
          severity: 'success',
          summary: Constant.suiviTitle,
          detail: response.message
        });

        this.ngxService.stop();
        this.getRecommandationByMission(this.localstorage.getRecommandation());

        //  ferme seulement CE modal
        modal.close(); // ou modal.dismiss()

      },
      (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error.error.message
        });

        this.ngxService.stop();
      }
    );
  }


  updateRecomandation(modal: any) {
    this.updateitem.mission_id = this.mission.reference;

    this.ngxService.start();

    this.paramservice.updateRecommndation(this.updateitem, this.updateitem.reference).subscribe(
      (response: any) => {
        this.messageService.add({
          severity: 'success',
          summary: Constant.suiviTitle,
          detail: response.message
        });

        this.ngxService.stop();
        this.getRecommandationByMission(this.mission);

        //  ferme seulement CE modal
        modal.close(); // ou modal.dismiss()

      },
      (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error.error.message
        });

        this.ngxService.stop();
      }
    );
  }
  // getTypeMission() {
  //   this.paramservice.getTypeMission().subscribe(
  //     (response: any) => {
  //       this.typemissionItems = response.data
  //       //console.log("this.typemissionItems", this.typemissionItems);
  //     },
  //     (error) => {
  //       ////console.log("une erreur est survenu", error);
  //     }
  //   );
  // }

  // getMission(item: any) {
  //   let requestData = {
  //     type_id: item
  //   }
  //   this.paramservice.getMission(requestData).subscribe(
  //     (response: any) => {
  //       this.missionItems = response.data
  //       this.getService();
  //       ////console.log("this.actionData", this.revuBudgetaire);
  //     },
  //     (error) => {
  //       ////console.log("une erreur est survenu", error);
  //     }
  //   );
  // }

  getService() {

    this.paramservice.fetchDataService().subscribe(
      (response: any) => {
        this.serviceItems = response.data
        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }


  //confirme la suppression
  confirmDeletion(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer cette recommandation ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deleteReccomandation(item.reference).subscribe(

          (response: any) => {
            this.ngxService.stop();
            ////console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.getRecommandationByMission(this.mission);
          },
          (error) => {
            ////console.log("une erreur est survenu",error);
            this.ngxService.stop();
            this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: error });

          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'error', summary: 'X-Project', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }//end confirmDelet
}